<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">REPORTES POR EMPRESA</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <!--Isquierda-->
          <div class="col-12 col-md-6">
            <h6>Lista de Empresas</h6>
            <div class="table-responsive" style="overflow-y:scroll; height:360px;">
              <table class="table table-striped table-bordered" v-if="!cargando && empresas.length > 0">
                <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">RAZÓN SOCIAL</small></th>
                    <th><small class="font-weight-bold">RUBRO</small></th>
                    <th><small class="font-weight-bold">ACCIÓN</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in empresas" :key="index">
                    <td class="text-center">
                      <small>{{ index + 1 }}</small>
                    </td>
                    <td>
                      <small>{{ item.emp_razon_social }}</small><br>
                      <small class="font-size-10">NIT: {{ item.emp_nit }}</small>
                    </td>
                    <td>
                      <small>{{ item.rubro_descripcion }}</small>
                    </td>
                    <td class="text-center">
                      <a class="btn btn-outline-info btn-sm"
                        @click="registrarParte(item)"
                        title="Mas Detalles">
                        <i class="fa fa-chevron-right"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--Derecha-->
          <div class="col-12 col-md-6">
            <h6>Detalle de Parte: <small>{{empresaElegida.emp_razon_social}} </small></h6>
            <!-- <p>
              <small>{{empresaElegida.emp_razon_social}}</small><br>
              <small>Rubro: {{empresaElegida.rubro_descripcion}}</small>
            </p>  -->
            <div class="table-responsive mt-3" style="overflow-y:scroll; height:360px;">
              <table class="table table-striped table-bordered" v-if="empresaElegida.id_rubro == 1">
                <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
                    <th><small class="font-weight-bold">DATOS</small></th>
                    <th><small class="font-weight-bold">TOTAL</small></th>
                    <th><small class="font-weight-bold">ACCIONES</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in partesEmpresa" :key="index">
                    <!--1-->
                    <td class="text-center"><small>{{ index + 1 }}</small></td>
                    <!--2-->
                    <td>
                      <small>{{ item.fecha_reg }}</small>
                    </td>
                    <!--3-->
                    <td>
                      <small>{{ 'Tipo Vuelo: '+ item.tipo_vuelo }}</small><br />
                      <small>{{ 'Nro Vuelo: '+ item.nro_vuelo }}</small>
                    </td>
                    <!--4-->
                    <td class="text-center">
                      <small>{{ item.totalregistros }}</small>
                    </td>
                    <!--5-->
                    <td class="text-center">
                      <a 
                        class="btn btn-outline-primary btn-sm mr-1" 
                        @click="showModal(1, item)"
                      >
                        <i class="fa fa-search"></i> 
                      </a>
                      <a class="btn btn-outline-success btn-sm"
                        title="Descargar Manifiesto"
                        @click="exportarXls(1, item)"
                      >
                        <i class="fa fa-download"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            
              <table class="table table-striped table-bordered" v-if="empresaElegida.id_rubro == 2">
                <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
                    <th><small class="font-weight-bold">DATOS</small></th>
                    <th><small class="font-weight-bold">TOTAL</small></th>
                    <th><small class="font-weight-bold">ACCIONES</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in partesEmpresa" :key="index">
                    <!--1-->
                    <td class="text-center"><small>{{ index + 1 }}</small></td>
                    <!--2-->
                    <td class="text-center">
                      <small>{{ getDateTime(item.fecha_reg) }}</small>
                    </td>
                    <!--3-->
                    <td>
                      <small>{{ 'Placa: '+ item.placa }}</small><br />
                      <small>{{ 'N° de Bus: '+ item.numero_bus }}</small>
                    </td>
                    <!--4-->
                    <td class="text-center">
                      <small>{{ item.totalregistros }}</small>
                    </td>
                    <!--5-->
                    <td class="text-center">
                      <a class="btn btn-outline-primary btn-sm mr-1" @click="showModal(2,item)"><i class="fa fa-search"></i> </a>
                      <a class="btn btn-outline-success btn-sm"
                        title="Descargar Parte"
                        @click="exportarXls(2, item)">
                        <i class="fa fa-download"></i>
                      </a>
                    
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="table table-striped table-bordered" v-if="empresaElegida.id_rubro == 3">
                <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">FECHA</small></th>
                    <th><small class="font-weight-bold">TOTAL<br>REGISTRO</small></th>
                    <th><small class="font-weight-bold">FECHA<br>REGISTRO</small></th>
                    <!-- <th><small class="font-weight-bold">ESTADO</small></th>-->
                    <th><small class="font-weight-bold">ACCIONES</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in partesEmpresa" :key="index">
                    <!--1-->
                    <td class="text-center"><small>{{ index + 1 }}</small></td>
                    <!--2-->
                    <td class="text-center"><small>{{'DE ' + getDate(item.fecha_inicio)}}<br>AL {{ getDate(item.fecha_fin)}}</small></td>
                    <td class="text-center">
                      <small v-if="item.observacion=='S/M'">DECLARACIÓN<br>SIN MOVIMIENTO</small>
                      <small v-else>{{item.total_registros}}</small>
                    </td>
                    <td class="text-center"><small>{{getDateTime(item.fecha_reg)}}</small></td>
                    <!-- <td class="text-center">
                      <span v-if="item.estado_proceso == 0 && item.verifica_estado == 1" class="badge badge-warning">PENDIENTE</span>
                      <span v-if="item.estado_proceso == 0 && item.verifica_estado == 0" class="badge badge-danger">VENCIDO</span>
                      <span v-if="item.estado_proceso == 1" class="badge badge-success">FINALIZADO</span>
                    </td> -->
                    <!--6-->
                    <td class="text-center">
                      <a class="btn btn-outline-primary btn-sm mr-1" @click="showModal(3,item)"><i class="fa fa-search"></i></a>
                      <a class="btn btn-outline-success btn-sm"
                        title="Descargar Parte"
                        @click="exportarXls(3, item)">
                        <i class="fa fa-download"></i>
                      </a>
                    </td>

                  </tr>
                </tbody>
              </table>

              <table class="table table-striped table-bordered" v-if="empresaElegida.id_rubro == 4">
                <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
                    <th><small class="font-weight-bold">DATOS</small></th>
                    <th><small class="font-weight-bold">TOTAL</small></th>
                    <th><small class="font-weight-bold">ACCIONES</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in partesEmpresa" :key="index">
                    <!--1-->
                    <td class="text-center"><small>{{ index + 1 }}</small></td>
                    <!--2-->
                    <td class="text-center">
                      <small>{{ getDateTime(item.fecha_reg) }}</small>
                    </td>
                    <!--3-->
                    <td>
                      <small>{{ 'Fecha inicio: '+ getDate(item.fecha_inicio) }}</small><br />
                      <small>{{ 'Fecha fin: '+ getDate(item.fecha_fin) }}</small>
                    </td>
                    <!--4-->
                    <td class="text-center">
                      <small>{{ item.totalregistros }}</small>
                    </td>
                    <!--5-->
                    <td class="text-center">
                      <a 
                        class="btn btn-outline-primary btn-sm mr-1" 
                        @click="showModal(4, item)"
                      >
                        <i class="fa fa-search"></i> 
                      </a>
                      <a class="btn btn-outline-success btn-sm"
                        title="Descargar Parte"
                        @click="exportarXls(4, item)"
                      >
                        <i class="fa fa-download"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>

               <table class="table table-striped table-bordered" v-if="empresaElegida.id_rubro == 5">
                <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
                    <th><small class="font-weight-bold">CARRERA</small></th>
                    <th><small class="font-weight-bold">CICLO ACADÉMICO</small></th>
                    <th><small class="font-weight-bold">ACCIONES</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in partesEmpresa" :key="index">
                    <!--1-->
                    <td class="text-center"><small>{{ index + 1 }}</small></td>
                    <!--2-->
                    <td class="text-center">
                      <small>{{ getDateTime(item.fecha_reg) }}</small>
                    </td>
                    <!--3-->
                    <td>
                      <small>{{ item.carrera }}</small>
                    </td>
                    <!--4-->
                    <td class="text-center">
                      <small>{{ item.observacion }}</small>
                    </td>
                    <!--5-->
                    <td class="text-center">
                      <a 
                        class="btn btn-outline-primary btn-sm mr-1" 
                        @click="showModal(5, item)"
                      >
                        <i class="fa fa-search"></i> 
                      </a>
                      <a class="btn btn-outline-success btn-sm"
                        title="Descargar Parte"
                        @click="exportarXls(5, item)"
                      >
                        <i class="fa fa-download"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table table-striped table-bordered" v-if="empresaElegida.id_rubro == 6">
                <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
                    <th><small class="font-weight-bold">FECHA INICIO</small></th>
                    <th><small class="font-weight-bold">FECHA FIN</small></th>
                    <th><small class="font-weight-bold">ACCIONES</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in partesEmpresa" :key="index">
                    <!--1-->
                    <td class="text-center"><small>{{ index + 1 }}</small></td>
                    <!--2-->
                    <td class="text-center">
                      <small>{{ getDateTime(item.fecha_reg) }}</small>
                    </td>
                    <!--3-->
                    <td>
                      <small>{{ getDate(item.fecha_inicio) }}</small>
                    </td>
                    <!--4-->
                    <td class="text-center">
                      <small>{{ getDate(item.fecha_fin )}}</small>
                    </td>
                    <!--5-->
                    <td class="text-center">
                      <a 
                        class="btn btn-outline-primary btn-sm mr-1" 
                        @click="showModal(6, item)"
                      >
                        <i class="fa fa-search"></i> 
                      </a>
                      <a class="btn btn-outline-success btn-sm"
                        title="Descargar Parte"
                        @click="exportarXls(6, item)"
                      >
                        <i class="fa fa-download"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>  
    </div>

    <b-modal
      class="modal fade"
      size="xl"
      hide-footer
      title="DETALLE DE PARTES"
      ref="modalDetalles"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row mb-1">   
          <div class="col-md-12">
            <p>
              {{empresaElegida.emp_razon_social}}<br>
              RUBRO: {{empresaElegida.rubro_descripcion}}<br>
              <!-- <span v-if="(elegido.id_rubro==3)">DETALLE DE PARTE REGISTRADO (Del: {{ elegido.fecha_inicio }} al {{elegido.fecha_fin}})</span> -->
              <span v-if="empresaElegida.id_rubro == 3">DE FECHA: {{fechaEstadoParte}}</span>
            </p>
          </div>        
          <div class="table-responsive" style="overflow-y:scroll; height:360px;" v-if="detalles.length>0">
            <table class="table table-striped table-bordered text-center" v-if="empresaElegida.id_rubro == 1">
              <thead class="text-center">
                  <tr>
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                    <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                    <th><small class="font-weight-bold">ORIGEN/DESTINO</small></th>
                  </tr>                        
              </thead>
              <tbody class="text-center">
                <tr v-for="(item, index) in detalles" :key="index">
                  <td><small>{{index+1}}</small></td>
                  <td><small>{{item.nombre_completo}}</small></td>
                  <td><small>{{item.nro_documento}}</small></td>
                  <td><small>{{item.nacionalidad}}</small></td>                     
                  <td><small>{{item.origen+'/'+item.destino}}</small></td>
                </tr>
              </tbody>
              
            </table>  

            <table class="table table-bordered text-center" v-if="(empresaElegida.id_rubro==2)">
              <thead>
                  <tr>
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                    <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                    <th><small class="font-weight-bold">ORIGEN/DESTINO</small></th>
                  </tr>                        
              </thead>
              <tbody >
                <tr v-for="(item, index) in detalles" :key="index">

                  <td><small>{{index+1}}</small></td>
                  <td><small>{{item.nombres}} {{item.apellidos}}</small></td>
                  <td><small>{{item.nro_documento}}</small></td>
                  <td><small>{{item.nacionalidad}}</small></td>
                  <td><small>{{item.origen+'/'+item.destino}}</small></td>                     
                </tr>
              </tbody>
              
            </table>

            <table class="table table-bordered" v-if="(empresaElegida.id_rubro==3)">
              <thead>
                <tr class="text-center">
                    <th><small class="font-weight-bold">NRO.</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                    <th><small class="font-weight-bold">FECHA NACIMIENTO</small></th>
                    <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                    <th><small class="font-weight-bold">FECHA REGISTRO</small></th> 
                </tr>                        
              </thead>
              <tbody>
                <tr v-for="(item, index) in detalles" :key="index">
                  <td class="text-center"><small>{{index+1}}</small></td>
                  <td><small>{{item.nombre_completo}}</small></td>
                  <td class="text-center"><small>{{item.fecha_nacimiento}}</small></td> 
                  <td class="text-center"><small>{{item.nro_documento}}</small></td>
                  <td class="text-center"><small>{{item.nacionalidad}}</small></td>                     
                  <td class="text-center"><small>{{item.fecha_reg}}</small></td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered text-center" v-if="(empresaElegida.id_rubro==4)">
              <thead>
                  <tr>
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                    <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                    <th><small class="font-weight-bold">ORIGEN/DESTINO</small></th>
                  </tr>                        
              </thead>
              <tbody >
                <tr v-for="(item, index) in detalles" :key="index">
                  <td><small>{{index+1}}</small></td>
                  <td><small>{{item.nombre_completo}}</small></td>
                  <td><small>{{item.nro_documento}}</small></td>
                  <td><small>{{item.nacionalidad}}</small></td>
                  <td><small>{{item.origen+'/'+item.destino}}</small></td>                     
                </tr>
              </tbody>
              
            </table>

            <table class="table table-bordered text-center" v-if="(empresaElegida.id_rubro==5)">
              <thead>
                  <tr>
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                    <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                    <th><small class="font-weight-bold">FECHA NACIMIENTO</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                  </tr>                        
              </thead>
              <tbody >
                <tr v-for="(item, index) in detalles" :key="index">
                  <td><small>{{index+1}}</small></td>
                  <td><small>{{item.nombres+' '+item.apellidos}}</small></td>
                  <td><small>{{item.nro_documento}}</small></td>
                  <td><small>{{getDate(item.fecha_nacimiento)}}</small></td>                     
                  <td><small>{{item.nacionalidad}}</small></td>
                </tr>
              </tbody>
            </table>
            <table class="table table-bordered text-center" v-if="(empresaElegida.id_rubro==6)">
              <thead>
                  <tr>
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                    <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                    <th><small class="font-weight-bold">FECHA NACIMIENTO</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                  </tr>                        
              </thead>
              <tbody >
                <tr v-for="(item, index) in detalles" :key="index">
                  <td><small>{{index+1}}</small></td>
                  <td><small>{{item.nombres+' '+item.apellidos}}</small></td>
                  <td><small>{{item.nro_documento}}</small></td>
                  <td><small>{{getDate(item.fecha_nacimiento)}}</small></td>                     
                  <td><small>{{item.nacionalidad}}</small></td>
                </tr>
              </tbody>
            </table>
          </div>              
        </div>
        <div class="row float-right">
          <a class="btn btn-outline-secondary" @click="hideModal">Cerrar</a>
        </div>
      </div>
    </b-modal>

    <Loading v-show="cargando" />
  </div>
</template>

<script>


import {required} from "vuelidate/lib/validators";
import Loading from "../../components/Loading";
import moment from "moment";


export default {
  name: "reportes",
  components: {
    Loading,
  },
  data() {
    return {
      empresaElegida:{},
      partesEmpresa: [],
      registros: [],
      detalles: [],
      id_empresa: 0,
      empresas: [],
      elegido: {},
      rubroBuscar: '',
      empresa: {
        //departamento: 'LPG',
        emp_latitud: 0,
        emp_longitud: 0
      },
      cargando: false,
      tituloModal: "Registro Empresa",
      departamentos: [],
       imagen: {
        base64: '',
        content: ''
      },
      municipios: [],
      rubros: [],
      persona: {},
      controBoton: true,
      departamento: '',
      fechaEstadoParte: '',
    };
  },
  methods: {
    showModal( rubro, item ) {
      this.elegido = item;
      switch(rubro){
        case 1:
          this.detallePartesAereo(item.id_aereo);
          this.$refs["modalDetalles"].show();
        break;
        case 2:
          this.detallePartesTerrestre(item.id_terrestre);
          this.$refs["modalDetalles"].show();
        break;
        case 3:
          //this.detallePartesChek(item.id_empresa);
          this.detallePartesHospedaje(item.id_hotel);
          this.$refs["modalDetalles"].show(); 
        break;
        case 4:
          this.detallePartesAgencia(item.id_agencia);
          this.$refs["modalDetalles"].show();
        break;
        case 5:
          this.detallePartesInstitucion(item.id_institucion);
          this.$refs["modalDetalles"].show();
        break;
        case 6:
          this.detallePartesNocturna(item.id_nocturna);
          this.$refs["modalDetalles"].show();
        break;
      }
    },
    hideModal() {
      this.$refs["modalDetalles"].hide();
    },

    async registrarParte(empresa) {
      this.cargando = true;
      //console.log("empresa",empresa);
      this.empresaElegida = empresa;
      let ruta = `/empresa/partesEmpresa/${empresa.id_empresa}`;
      switch(empresa.id_rubro){
        case "1":
          ruta = `/empresa/partesEmpresaAerea/${empresa.id_empresa}`;
        break;
        case "2":
          ruta = `/empresa/partesTerrestresEmpresa/${empresa.id_empresa}`;
        break;
        case "3":
         //ruta = `/empresa/reporteCentroHospedaje/${empresa.id_empresa}`;
          ruta = `/historial/partesHospesaje/${empresa.id_empresa}`;
        break;
        case "4":
          ruta = `/empresa/partesAgenciaEmpresa/${empresa.id_empresa}`;
        break;
        case "5":
          ruta = `/historialInstitucion/partes/${empresa.id_empresa}`;
        break;
        case "6":
          ruta = `/historialNocturna/partes/${empresa.id_empresa}`;
        break;
      }
      
      try {
        let res = await this.axios.get(ruta);
        this.cargando = false;
        if(res.status == 200){
          this.partesEmpresa = res.data.contenido;
          if(empresa.id_rubro == "3"){
            this.partesEmpresa = res.data.contenido;
            let fecha = moment(this.partesEmpresa[0].fecha_reg).format('YYYY-MM-DD');
            if(fecha == '1900-01-01'){
              this.partesEmpresa = '';
            }
          }
          
        }
      } catch (error) {
        this.cargando = false;
      }
    },
    async listarDatos(id_empresa) {
      try {
        this.resultados = await this.axios.get(`/empresa/partesEmpresa/${id_empresa}`);
        this.registros = this.resultados.data.contenido;
        
      } catch (error) {
        console.log(error);
        
      }
    },
    async getEmpresasByRubros(rubroBuscar) {
      this.registros = [];
      try {
        let resultados = await this.axios.get(`/empresasReporte/${rubroBuscar}`);
        this.empresas = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ',error);
      }
    },
    async detallePartes(id_parte) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historial/detalle/${id_parte}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async detallePartesChek(item, id_empresa) {
      let fecha = item.fecha;
      this.fechaEstadoParte = this.getDate(fecha);
      this.cargando = true;
      try {
       //let res = await this.axios.get(`/historialParteEmpresa/detalle/${id_empresa}/${id_parte}`);
       let res = await this.axios.get(`/historial/detalleHospedaje/${id_empresa}/${fecha}`);
        //let res = await this.axios.get(`/partes/personasPartesporEmpresa/${id_empresa}/${fecha_inicio}/${fecha_fin}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async getDepartamentos() {
      try {
        let resultados = await this.axios.get(`/getDepartamentos`);
        this.departamentos = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async getMunicipios(par_cod_depto) {
      try {
        let resultados = await this.axios.get(`/getMunicipio/${par_cod_depto}`);
        this.municipios = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async getRubros() {
      try {
        let resultados = await this.axios.get(`/getRubros`);
        this.rubros = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async getEmpresas(id_persona) {
      try {
        let resultados = await this.axios.get(`/empresas/${id_persona}`);
        this.empresas = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    // crearDescarga(response, title) {
    //   const url = window.URL.createObjectURL(new Blob([response.data], { type: 'blob' }));
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.setAttribute('download', title);
    //   document.body.appendChild(link);
    //   link.click();
    // },
    // async exportarXls(codigo_departamento, id_rubro, id_empresa, fecha_inicio, fecha_fin){
    //   let config = { headers: {token: this.token}, responseType: 'blob'};
    //   this.cargando= true;
    //   try {
    //     this.resultados = await this.axios.get(`/partes/personasPartesporEmpresa/${id_empresa}/${fecha_inicio}/${fecha_fin}`, config);
    //     await this.crearDescarga(this.resultados, 'reporte.xlsx');
    //     this.cargando = false;
    //   } catch (error) {
    //     console.log(error);
    //     this.cargando = false;
    //   }
    // },
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'blob' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
    },
    async exportarXls(rubro, empresa){
      let config = { headers: { token: this.token }, responseType: 'blob' };
      this.cargando = true;

      let fecha = '';
      let fecha_ini = '';  
      let fecha_sal = '';
      let id_empresa = 0;
      //let nombreEmpresa = '';
      let nombreEmpresa = this.empresaElegida.emp_razon_social;

      if(rubro == 1 || rubro == 2){
        fecha = empresa.fecha_reg;
        fecha = moment(fecha).format("YYYY-MM-DD HH:mm:ss");
      }
      if(rubro == 3){
        // id_empresa = this.empresaElegida.id_empresa;
        // fecha = empresa.fecha;     
        // fecha = moment(fecha).format("YYYY-MM-DD");
        fecha = empresa.fecha;     
        fecha = moment(fecha).format("YYYY-MM-DD HH:mm:ss");
        fecha_ini = empresa.fecha_inicio;     
        fecha_sal = empresa.fecha_fin;
        fecha_ini = moment(fecha_ini).format("YYYY-MM-DD");
        fecha_sal = moment(fecha_sal).format("YYYY-MM-DD");
      }
      if(rubro == 4){
        fecha = empresa.fecha;     
        fecha = moment(fecha).format("YYYY-MM-DD HH:mm:ss");
        fecha_ini = empresa.fecha_inicio;     
        fecha_sal = empresa.fecha_fin;
        fecha_ini = moment(fecha_ini).format("YYYY-MM-DD");
        fecha_sal = moment(fecha_sal).format("YYYY-MM-DD");
      }
      if(rubro == 5){
        fecha = empresa.fecha_reg;     
        fecha = moment(fecha).format("YYYY-MM-DD HH:mm:ss");
        id_empresa = empresa.id_institucion;
      }
      if(rubro == 6){
        fecha = empresa.fecha_reg;     
        fecha = moment(fecha).format("YYYY-MM-DD HH:mm:ss");
        id_empresa = empresa.id_institucion;
        fecha_ini = empresa.fecha_inicio;     
        fecha_sal = empresa.fecha_fin;
        fecha_ini = moment(fecha_ini).format("YYYY-MM-DD");
        fecha_sal = moment(fecha_sal).format("YYYY-MM-DD");
      }

      // let fecha = empresa.fecha_reg;
      // let fecha_ini = empresa.fecha_inicio;     
      // let fecha_sal = empresa.fecha_fin;
      // fecha = moment(fecha).format("DD-MM-YYYY HH:mm:ss");
      // fecha_ini = moment(fecha_ini).format("DD-MM-YYYY HH:mm:ss");
      // fecha_sal = moment(fecha_sal).format("DD-MM-YYYY HH:mm:ss");

      
      try {
        switch(rubro){
          case 1:
            this.resultados = await this.axios.get(`/reporteEmpresaAereaParte_xls/${empresa.id_aereo}/${empresa.tipo_vuelo}/${empresa.nro_vuelo}/${fecha}`, config);                
          break;
          case 2:
            this.resultados = await this.axios.get(`/reporteEmpresaTerrestreParte_xls/${empresa.id_terrestre}/${nombreEmpresa}/${empresa.placa}/${empresa.numero_bus}/${fecha}`, config);  
           break;
          case 3:
            //this.resultados = await this.axios.get(`/reporteCentroHospedaje_xls/${id_empresa}/${fecha}/${nombreEmpresa}`, config);
            this.resultados = await this.axios.get(`/reporteEmpresaHospedajeParte_xls/${nombreEmpresa}/${empresa.id_hotel}/${fecha_ini}/${fecha_sal}/${fecha}`, config);
          break;
          case 4:
            this.resultados = await this.axios.get(`/reporteEmpresaAgenciaParte_xls/${nombreEmpresa}/${empresa.id_agencia}/${fecha_ini}/${fecha_sal}/${fecha}`, config);                
          break;
          case 5:
            this.resultados = await this.axios.get(`/reporteEmpresaInstitucion_xls/${id_empresa}/${fecha}/${nombreEmpresa}`, config);                
          break;
          case 6:
            this.resultados = await this.axios.get(`/reporteEmpresaNocturnaParte_xls/${nombreEmpresa}/${empresa.id_nocturna}/${fecha_ini}/${fecha_sal}/${fecha}`, config);                
          break;
        }
        
        await this.crearDescarga(this.resultados, 'reporte.xlsx');
        
       // this.registros = this.resultados.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      } 
    },
    getDate: function(date) {
      if(date != "" && date != undefined){
        return moment(date).format("DD/MM/YYYY");
      }
      else{
        return '';
      }
    },
    getDateTime: function(date) {
      if(date != "" && date != undefined){
        return moment(date).format("DD/MM/YYYY HH:mm:ss");
      }
      else{
        return '';
      }
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("/");
      return arrayFecha[2] + "-" + arrayFecha[1] + "-" + arrayFecha[0];
    },
    async listarDato() {
      let config = { headers: { token: this.token } };
      try {
        this.resultados = await this.axios.get(`/personaGetDataLogin`, config);
        this.persona = this.resultados.data.contenido;
        this.getEmpresas(this.persona.id_persona);
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async detallePartesAereo(id) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historial/detalleAereo/${id}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async detallePartesHospedaje(id) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historial/detalleHospedaje/${id}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async detallePartesTerrestre(id) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historialTerrestres/detalle/${id}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async detallePartesAgencia(id) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historial/detalleAgencia/${id}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async detallePartesInstitucion(id) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historialInstitucion/detalle/${id}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async detallePartesNocturna(id) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historialNocturna/detalle/${id}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },

  },
  created() {
    this.listarDato();
    //this.getDepartamentos();
    //this.getRubros();
  },
  validations: {
    empresa: {
      emp_razon_social: { required },
      emp_nit: { required },
      emp_licencia: { required },
      emp_telefono: { required },
      codigo_departamento: { required },
      id_municipio: { required },
      emp_direccion: { required },
      id_rubro: { required },
      tipo_servicio: { required },
      emp_latitud: { required },
      emp_longitud: { required }
    },
  },
};
</script>
